import { request } from '@bizfly/shared';
import { getNewEndpoint } from '../config/newEndpoint';

async function createProject(data) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.PROJECTS}`,
    method: 'post',
    data,
  });
}

async function updateProject(uuid, data) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.PROJECTS}/${uuid}`,
    method: 'put',
    data,
  });
}

async function listProjects(params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: NEW_ENDPOINT.PROJECTS,
    method: 'get',
    params,
  });
}

async function deleteProject(uuid) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.PROJECTS}/${uuid}`,
    method: 'delete',
  });
}

async function getProject(uuid) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.PROJECTS}/${uuid}`,
    method: 'get',
  });
}

async function listUsers(uuid, params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  const url = `${NEW_ENDPOINT.PROJECTS}/${uuid}/users`;
  return request({
    url,
    params,
    method: 'get',
  });
}

export default {
  createProject,
  updateProject,
  listProjects,
  deleteProject,
  getProject,
  listUsers,
};
